import Action from './action';

const initialState = {
    BankCardNumber: '',
    errorText: '',
};

export default (state = initialState, action: {type: string, playload: string}) => {
    switch (action.type) {
        case Action.UPDATE_BANK_CARD_NUMBER: {
            return {
                ...state,
                BankCardNumber: action.playload
            }
        }
        case Action.UPDATE_BANK_CARD_NUMBER_ERROR_TEXT: {
            try {
                action.playload && (window as any).mailStats.show('BankCardNumber_error', { errorText: action.playload })
            } catch(e) {}
            return {
                ...state,
                errorText: action.playload
            }
        }
        default: return state;
    }
}
